import { ApiClientFactory } from "common/middleware/api.client-factory";
import { DeclineRequestOpportunityChatCommand } from "common/middleware/api.services";

export const declineRequestToChat = async (opportunityId: string) => {
  const client = await ApiClientFactory.getSharedOpportunitiesClient();
  await client.declineRequestToChat(opportunityId, new DeclineRequestOpportunityChatCommand());
}
